import FilterListItemAbstract from "../../Abstract/Filter/FilterListItemAbstract";
import { HBox, PuzzleButton, VBox } from "puzzle";
import React from "react";
import * as _ from "lodash";

class AdvancedSearchListShowHideItem extends FilterListItemAbstract<{}, {}> {
  supplierView = true;
  countProperty: 'submissionCount' | 'jobPhaseCount' = 'jobPhaseCount';
  updateDialogSavedSearches = true;

  moduleDidMount = () => {
    this.setState({
      additionalLiClassName: `tp-tasks-filter-list ${this.props.currentItem.filterId === this.props.editedFilterId ? 'tp-marked-filter' : ''}`
    })
  };

  componentDidUpdate(prevProps: Readonly<{}>) {
    if (!_.isEqual(prevProps, this.props)) {
      this.setState({
        additionalLiClassName: `tp-tasks-filter-list ${this.props.currentItem.filterId === this.props.editedFilterId ? 'tp-marked-filter' : ''}`
      });
    }
  }

  /**
   * Override
   */
  handleEnter = () => {
    //TODO create method for handle enter
  };

  /**
   * Override
   */
  handleFilterClick = (event: any) => {
    this.props.onSearchClick(this.props.currentItem, event);
  };

  /**
   * @inheritdoc
   */
  renderActions = () => {
    const { currentItem, showHideSearch, deleteSearch } = this.props;
    const showHideAriaLAbel = currentItem.isFavorite ? this.translate('SRL-hideFilter') : this.translate('SRL-showFilter');
    return (<HBox alignItemsCenter gap={2} className={'saved-filter-btns k-mr-2'}>
      <PuzzleButton
        aria-label={showHideAriaLAbel}
        titleText={showHideAriaLAbel}
        tabIndex={0}
        fillMode={'flat'}
        size={'small'}
        iconClass={`tp-icon ${currentItem.isFavorite ? "tp-eye-open" : "tp-eye-closed"}`}
        onClick={showHideSearch.bind(this, currentItem)}
        tooltipPosition={'right'}
        withTooltip
      />
      <PuzzleButton
        aria-label={this.translate('SRL-deleteFilter')}
        titleText={this.translate('SRL-deleteFilter')}
        tabIndex={0}
        fillMode={'flat'}
        size={'small'}
        iconClass={'tp-icon tp-delete'}
        onClick={deleteSearch.bind(this, currentItem)}
        tooltipPosition={'right'}
        withTooltip
      />
    </HBox>)
  };

  /**
   * @inheritdoc
   */
  renderSearchNameWithCount = () => {
    const {
      jobPhaseCount,
      filterName
    } = this.props.currentItem;
    return (
      <VBox
        displayFlex
        gap={1}
        flex1
        className={'tp-filter-list-item-wrap tp-100'}
      >
        <div className="tp-filter-list-item-name" tabIndex={-1}>{filterName}</div>
        {
          _.isUndefined(jobPhaseCount) ?
            (<HBox className={'tp-color-light-LM'}>
              <i className={'tp-icon tp-font-size-md tp-loop'} aria-hidden={"true"} />
              <span className={'tp-font-size-sm'}>{this.translate('tasks')}</span>
            </HBox>)
            :
            (<div className="tp-filter-list-task-count tp-font-size-sm tp-color-light-LM"
                  tabIndex={-1}>{jobPhaseCount + ' ' + this.translate('tasks')}</div>)
        }
      </VBox>)
  }

}

export default AdvancedSearchListShowHideItem;
